import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import PrimeNotificationPayload from 'owa-service/lib/contract/PrimeNotificationPayload';
import loadActivityFeed from '../utils/loadActivityFeed';

// This should always be in sync with the PrimeNotificationTypes
// being set in Prime every time the Activity Feed updates.
enum PrimeNotificationType {
    DeleteActivityFeedCollection = 'DeleteActivityFeedCollection',
    MarkActivityFeedItemsAsDismissed = 'MarkActivityFeedItemsAsDismissed',
    MarkActivityFeedItemsAsRead = 'MarkActivityFeedItemsAsRead',
    MarkActivityFeedItemsAsSeen = 'MarkActivityFeedItemsAsSeen',
    UpsertActivityFeedItem = 'UpsertActivityFeedItem',
}

function onPrimeNotificationCallback(notification: PrimeNotificationPayload): void {
    switch (notification.PrimeNotificationType) {
        case PrimeNotificationType.DeleteActivityFeedCollection:
        case PrimeNotificationType.MarkActivityFeedItemsAsDismissed:
        case PrimeNotificationType.MarkActivityFeedItemsAsRead:
        case PrimeNotificationType.MarkActivityFeedItemsAsSeen:
        case PrimeNotificationType.UpsertActivityFeedItem:
            loadActivityFeed();
    }
}

export default function subscribeToPrimeNotification(): void {
    const subscription: NotificationSubscription = {
        subscriptionId: 'Prime Notification',
        requiresExplicitSubscribe: false,
        subscriptionParameters: {},
    };

    lazySubscribe.importAndExecute(subscription, onPrimeNotificationCallback);
}
